<template>
  <div class="w-full">
    <div class="flex flex-col items-right relative">
      <div class=" grid grid-cols-12">
        <div class="col-span-2 mt-2" >
          <spinner v-if="showSpinner"/>
        </div>
        <label class="col-span-10 text-sm font-medium text-gray-700">{{ label }}
          <div class="my-2 p-1 bg-white flex border focus:border-gray-200 rounded">
            <input :placeholder="placeholder"
                   class="p-1 px-2 appearance-none outline-none w-full text-gray-800 active:bg-blue"
                   @focus="changeShowDetail" @keyup="isShow"
                   @keyup.esc="changeShowDetail"
                   v-model="text" ref="autocomplete">
            <div class="text-gray-300 w-8 py-1 pl-2 pr-1 border-l flex items-center border-gray-200">
              <button class="cursor-pointer w-6 h-6 text-gray-600 outline-none focus:outline-none"
                      @touchstart="changeShowDetail" type="button" @click.prevent="changeShowDetail">
                <font-awesome-icon icon="chevron-up" v-if="showDetail"></font-awesome-icon>
                <font-awesome-icon icon="chevron-down" v-else></font-awesome-icon>
              </button>
            </div>
          </div>
        </label>
      </div>

      <div v-if="showDetail"
           class="absolute shadow bg-white top-100 w-full lef-0 rounded max-h-select overflow-y-auto svelte-5uyqqj max-h-select"
           ref="autocompletedetail" style="z-index: 1000">
        <ul class="flex flex-col w-full">
          <li class="cursor-pointer w-full border-gray-200 rounded-t border-b  py-2 "
              :class="indexElementActive===index ? 'bg-blue-300': ''"
              v-for="(item, index) in searching" :key="index" @click="selectItem(item)"
              :ref="refElement(index)">
            <div
                class="flex w-full items-center p-2 pl-2 border-transparent border-l-2 relative hover:border-teal-100">
              <div class="w-6 flex flex-col items-center" v-if="item.img">
                <div
                    class="flex relative w-5 h-5 bg-orange-500 justify-center items-center m-1 mr-2 w-4 h-4 mt-1 rounded-full ">
                  <img class="rounded-full" alt="A" :src="item.img">
                </div>
              </div>
              <div class="w-full items-center flex">
                <div class="mx-2 -mt-1  ">{{ item[textfield] }}
                  <div class="text-xs truncate w-full normal-case font-normal -mt-1 text-gray-500">
                    {{ item.description }}
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import {OpenStreetMapProvider} from 'leaflet-geosearch';
import spinner from './spinner.vue';

export default {
  components: { spinner },
  name: "searchMap",
  props: {
    textfield: {
      type: String,
      default: 'label'
    },
    placeholder: {
      type: String,
      default: 'Search'
    },
    label: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    showDetail: false,
    text: '',
    showSpinner: false,
    lengthElements: [],
    indexElementActive: null,
    searching: []
  }),
  methods: {
    changeShowDetail() {
      this.showDetail = !this.showDetail
    },
    selectItem(item) {
      this.$emit('change', item)
      this.text = item[this.textfield]
      this.showDetail = false
    },
    isShow(e) {
      if (e.keyCode === 27) {
        this.showDetail = false
        return null
      } else {
        setTimeout(() => {
          this.buscar()
        }, 2000)
        if (!this.showDetail) this.showDetail = true
      }
    },
    refElement(index) {
      return `element${index}`
    },
    removeAccents(str) {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    async buscar() {
      this.showSpinner=true
      const provider = new OpenStreetMapProvider({
        params: {
          countrycodes: 'sv', // limit search results to Canada & United States
        },
      });
      this.searching = await provider.search({query: this.text})
      this.showSpinner=false
    }
  }
}
</script>

<style scoped>
.top-100 {
  top: 100%
}

.bottom-100 {
  bottom: 100%
}

.max-h-select {
  max-height: 300px;
}
</style>